import * as React from 'react';
import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import useMetadata from 'hook/useMetadata';
import { useGetAllEntityTypesQuery, useGetAllPropertyTypesQuery } from 'services/metadataApi';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { extractEntityParameterValue } from 'utils/entityUtils';
import useConf from 'hook/useConf';
import { useGetConfigurationQuery } from 'services/applicationApi';
import FilesList from 'components/Lists/FilesList';
import Box from '@mui/material/Box';
import MDInput from 'components/MDInput';

EntityDetails.propTypes = {
  view: PropTypes.string.isRequired,
  entity: PropTypes.object.isRequired
};

export function EntityDetails({ view, entity }) {
  const { getValue: conf } = useConf(useGetConfigurationQuery);

  const theme = useTheme();
  const isSmallMedia = useMediaQuery(theme.breakpoints.down('sm'));

  const { getTitle: getEntityTypeTitle } = useMetadata(useGetAllEntityTypesQuery, 'entityType');
  const { getTitle: getPropertyTypeTitle } = useMetadata(
    useGetAllPropertyTypesQuery,
    'propertyType'
  );

  const entityParameters = entity.parameters.filter((param) => param.value);
  const entityDocuments = [entity, ...(entity.children || [])]
    .filter((entity) => entity.entityTypeType === 'DOCUMENT')
    .map((entity) => ({
      entityId: entity.id,
      label: entity.name,
      type: entity.entityTypeCode,
      contentId: entity.contentId,
      mimeType: entity.mimeType,
      contentLen: entity.contentLen,
      hash: entity.hash
    }));

  return (
    <>
      <Divider variant="middle" textAlign="left" role="presentation">
        {getEntityTypeTitle(entity.entityTypeCode)}
      </Divider>
      <Grid container spacing={isSmallMedia ? 1 : 2}>
        {entityParameters.map((param) => {
          const value = extractEntityParameterValue(param, conf(`${view}.dateTimeformat`));
          return (
            <Grid item key={param.id} xs={12} sm={6} md={4} xl={3}>
              <MDInput
                fullWidth
                label={getPropertyTypeTitle(param.propertyTypeCode)}
                defaultValue={value}
                InputProps={{
                  readOnly: true
                }}
                variant="standard"
              />
            </Grid>
          );
        })}
        {entityDocuments && (
          <>
            <Box width="100%" />
            <Grid item>
              <FilesList files={entityDocuments} viewName={view} />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}

PreviewPanel.propTypes = {
  view: PropTypes.string.isRequired,
  entity: PropTypes.object.isRequired
};

export default function PreviewPanel({ view, entity }) {
  const entityPath = [entity];
  let curEntity = entity;
  while (curEntity.parent) {
    curEntity = curEntity.parent;
    entityPath.splice(0, 0, curEntity);
  }

  return (
    <>
      {entityPath.map((entity) => (
        <EntityDetails key={entity.id} view={view} entity={entity} />
      ))}
    </>
  );
}
